/*@flow*/
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { memo, useState, useEffect } from 'react';
import { Editor, EditorState, ContentState } from 'draft-js';

type PropsT = {
  value?: any,
  placeholder?: string,
  minWidth?: string,
  onChange?: string => any,
};

const Component = (props: PropsT) => {
  const [editorState, setState] = useState(EditorState.createEmpty());

  useEffect(() => {
    if (!props.value) return;
    const valueState = ContentState.createFromText(props.value);
    setState(EditorState.createWithContent(valueState));
  }, [props.value]);

  useEffect(() => {
    const content = editorState.getCurrentContent().getPlainText();
    props.onChange && props.onChange(content);
  }, [editorState]);

  return (
    <Editor
      editorState={editorState}
      onChange={v => setState(v)}
      placeholder={props.placeholder}
    />
  );
};

export default (memo<PropsT>(Component): React$AbstractComponent<PropsT, mixed>);
